// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ProductDetailClient = registerClientReference(
    function() { throw new Error("Attempted to call ProductDetailClient() from the server but ProductDetailClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/woocommerce-products/src/app/products/[id]/ProductDetailClient.tsx",
    "ProductDetailClient",
);
